// Tabs
// Small class that implements tabs behaviour

// Usage
// The top container should have the class `tabs`.
// It relies on adding a css class to the filter (`tabs-filter`) and the content of the tab (`tabs-tab`).
// Linking the filter with the content is done by adding the attribute `data-tabs` to both elements.


export default class Tabs {
    constructor(element) {
        this.tabsWrapper = element;

        this.filters = this.tabsWrapper.querySelectorAll(".tabs-filter");
        this.tabs = this.tabsWrapper.querySelectorAll(".tabs-tab")

        this.listenAnchor = this.tabsWrapper.getAttribute("data-tabs-listen-anchor") ? true : false


        this.previous = this.tabsWrapper.querySelector(".tabs-previous");
        this.next = this.tabsWrapper.querySelector(".tabs-next");

        for (const filter of this.filters) {
            filter.addEventListener('click', (e) => this.changeState(e))
        }

        this.initArrows();

        
        if (this.listenAnchor) {

            window.addEventListener('hashchange', () => {
                this.initAnchor(); 
            })

            this.initAnchor();
 
        }

    }

    changeState(e) {
        this.deactivateTabs();
        this.deactivateFilters();

        const tabs_id = e.target.closest(".tabs-filter").getAttribute("data-tabs");

        this.activateTab(tabs_id);
        this.activateFilter(tabs_id);
    }

    initArrows() {
        if (this.previous) {
            this.previous.addEventListener('click', () => this.previousTab());
        }

        if (this.next) {
            this.next.addEventListener('click', () => this.nextTab());
        }


        if (this.previous || this.next) {
            this.checkArrows();
        }
    }

    initAnchor() {
       const id = window.location.hash.slice(1); 

        if (id) {
            this.deactivateTabs();
            this.deactivateFilters();

            this.activateTab(id);
            this.activateFilter(id);
        }
    }

    previousTab() {
        const tab = this.getActiveTab();
        const previousTab = tab.previousElementSibling;

        if (previousTab) {
            this.deactivateTabs();
            this.deactivateFilters();

            this.activateTab(previousTab.getAttribute("data-tabs"));
            this.activateFilter(previousTab.getAttribute("data-tabs"));

            this.checkArrows();
        }
    }

    nextTab() {
        const tab = this.getActiveTab();
        const nextTab = tab.nextElementSibling;

        if (nextTab) {
            this.deactivateTabs();
            this.deactivateFilters();

            this.activateTab(nextTab.getAttribute("data-tabs"));
            this.activateFilter(nextTab.getAttribute("data-tabs"));

            this.checkArrows();
        }
    }

    checkArrows() {
        const tab = this.getActiveTab();
        const nextTab = tab.nextElementSibling;
        const previousTab = tab.previousElementSibling;

        if (nextTab) {
            this.next.style.opacity = 1;
        } else {
            this.next.style.opacity = 0.5;
        }

        if (previousTab) {
            this.previous.style.opacity = 1;
        } else {
            this.previous.style.opacity = 0.5;
        }
    }

    getActiveTab() {
        return this.tabsWrapper.querySelector(".tabs-tab.active");
    }

    activateTab(tabs_id) {
        for (const tab of this.tabs) {
            if (tab.getAttribute("data-tabs") !== tabs_id) continue;

            tab.classList.add("active");
        }
    }

    activateFilter(tabs_id) {
        for (const filter of this.filters) {
            if (filter.getAttribute("data-tabs") !== tabs_id) continue;

            filter.classList.add("active");
        }
    }

    deactivateTabs() {
        for (const tab of this.tabs) {
            tab.classList.remove("active")
        }
    }

    deactivateFilters() {
        for (const filter of this.filters) {
            filter.classList.remove("active")
        }
    }
}
